export const ScanResultType = {
  NoCodeDetected: "E1",
  UnknownCode: "E2",
  Counterfeit: "E3",
  Success: "E4",
  AlreadyScanned: "E5",
  Suspicious: "E6",
  UnknownError: "E7",
  OuterPackaging: "O1",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ScanResultType = (typeof ScanResultType)[keyof typeof ScanResultType];

export type OriginCheckResult = {
  type: ScanResultType;
  productCode?: string;
  dmcCode: string;
};

const POSITIVE_RESULTS: ScanResultType[] = [
  ScanResultType.Success,
  ScanResultType.Suspicious,
  ScanResultType.AlreadyScanned,
];
export function isPositiveScanResult(result: OriginCheckResult): boolean {
  return POSITIVE_RESULTS.includes(result.type);
}

export function getScanStatus(scanType: ScanResultType) {
  let status = "Unsuccessful";
  switch (scanType) {
    case ScanResultType.Success:
    case ScanResultType.AlreadyScanned:
      status = "Successful";
      break;
    case ScanResultType.Suspicious:
      status = "Suspicious";
      break;
    case ScanResultType.OuterPackaging:
      status = "Outer Packaging";
      break;
    case ScanResultType.Counterfeit:
      status = "Counterfeit";
      break;
  }
  return status;
}
